import React from "react";
import { iniciales } from "./plantillasWhatsapp";
import "./recordatorios.css";

/* Phone-like preview of a WhatsApp message built with sample values. `texto` already has them substituted. */

const VistaPreviaWhatsapp = ({ local, texto, pie = "" }) => {
  const parrafos = String(texto || "").split(/\n{2,}/);
  return (
    <div className="zr-field">
      <span className="zr-field__label">Vista previa</span>
      <div className="rwa-phone" role="group" aria-label="Vista previa del mensaje de WhatsApp">
        <div className="rwa-phone__head">
          <span className="zr-avatar zr-avatar--sm" aria-hidden="true">{iniciales(local)}</span>
          <div>
            <div className="rwa-phone__name">{local || "Tu local"}</div>
            <div className="rwa-phone__sub">Mensaje de WhatsApp</div>
          </div>
        </div>
        <div className="rwa-phone__chat">
          <div className="rwa-bubble">
            {parrafos.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            {pie && <p className="rwa-bubble__pie">{pie}</p>}
            <span className="rwa-bubble__hora">10:30</span>
          </div>
        </div>
      </div>
      <p className="rwa-ejemplo">Con los datos de Sofía Herrera, turno del viernes 30 de octubre.</p>
    </div>
  );
};

export default VistaPreviaWhatsapp;
